import { useEffect, useState } from 'react';

const useDeviceOrientation = () => {
  const getOrientation = () =>
    window.matchMedia('(orientation: portrait)').matches
      ? 'portrait'
      : 'landscape';

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)');

    const handleChange = () => {
      setOrientation(mediaQuery.matches ? 'portrait' : 'landscape');
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return orientation;
};

export default useDeviceOrientation;
